export const GAME_TITLE = "Mind Survival";

export const GAME_WIDTH = 960;
export const GAME_HEIGHT = 540;

/** Max simulated offline time applied on load (seconds). */
export const OFFLINE_CAP_SECONDS = 8 * 60 * 60;

/** Autosave interval while playing (ms). */
export const AUTOSAVE_MS = 15_000;

export const SAVE_KEY = "mind-survival/v1";
